// extracted by mini-css-extract-plugin
export default {"modalOuter":"Modal_modalOuter__V+CLj","modalInner":"Modal_modalInner__RJqgt"};